// DynamicFields.js
import { useEffect, useState } from 'react';
import InputFormik from '../../../../../../../../common/components/form/InputFormik';
import TextAreaFormik from '../../../../../../../../common/components/form/TextAreaFormik';
import { useFormikContext } from 'formik';
import { maskCurrency } from '../../../../../../../../common/helpers/mask.helpers';
import { DateSubscriptionFormik } from '../../../../../forms/fields/DateSubscriptionFormik';


const calculateTotalFines = (fields) => {
  return fields.reduce((total, field) => {
    // Remove a formatação de moeda antes de converter para float
    const numericValue = field.value.replace(/[R$.,]/g, "").replace(',', '.') / 100;
    return total + numericValue;
  }, 0);
};



const DynamicFields = () => {
  const { setFieldValue } = useFormikContext();
  const [fields, setFields] = useState([
    { value: "", description: "", billingDate: new Date().toISOString().slice(0, 10) }
  ]);

  const [, setTotalFines] = useState(0);

  useEffect(() => {
    const total = calculateTotalFines(fields);
    setTotalFines(total);
    setFieldValue('totalFines', total); // Atualiza o Formik com o total
  }, [fields, setFieldValue]);


  const handleAddField = () => {
    setFields([...fields, { value: "", description: "", billingDate: new Date().toISOString().slice(0, 10) }]);
  };


  const handleChange = (event, index, fieldName) => {
    const { value } = event.target;
    const updatedFields = [...fields];
    updatedFields[index][fieldName] = value;
    setFields(updatedFields);
    setFieldValue(`fields.${index}.${fieldName}`, value);
  };

  const handleDeleteField = (index) => {
    const newFields = [...fields];
    newFields.splice(index, 1);
    setFields(newFields);
    // Atualiza o estado do Formik para remover o campo
    setFieldValue('fields', newFields);
  };

  return (
    <section>
      <div>
        {fields.map((_, index) => (
          <div key={index}
            className={`flex flex-col my-4 p-4 rounded ${index % 2 ? 'bg-gray/15' : 'bg-gray/25'}`}>
            <InputFormik
              label='Digite o valor da multa de transito'

              name={`fields.${index}.value`}
              placeholder="Valor"
              onChange={(event) => handleChange(event, index, 'value')}
              mask={maskCurrency}
              className='flex-1'
            />

            <TextAreaFormik
              label='Descrição da multa de transito '
              name={`fields.${index}.description`}
              placeholder="Descrição"
              onChange={(event) => handleChange(event, index, 'description')}
              className='mt-4 flex-1'
            />
            <div>
              <DateSubscriptionFormik
                name={`fields.${index}.billingDate`}
              />
            </div>
            {fields.length > 1 && (
              <div className='flex justify-end'>
                <button
                  className='rounded-md text-white bg-redPrimary hover:text-white hover:bg-redPrimary/80 h-12 w-24 flex justify-center items-center'
                  type="button"
                  onClick={() => handleDeleteField(index)}
                >
                  Remover
                </button>
              </div>

            )}
          </div>
        ))}
      </div>
      <div className='flex justify-center'>
        <button
          type="button"
          className=" mt-4 pb-12 items-center h-12 rounded-md text-black"
          onClick={handleAddField}> + Adicionar Campo</button>
      </div>
    </section>
  );
};

export default DynamicFields;
